import type { ProcessBlueprintVersion } from '../../../../types/processBlueprint';
import type { VersionDiff } from '../../../services/version.service';

interface VersionHistoryTabProps {
  versions: ProcessBlueprintVersion[];
  diff: VersionDiff | null;
}

export function VersionHistoryTab({ versions, diff }: VersionHistoryTabProps) {
  if (!versions?.length) return <div className="text-sm text-gray-500">Nenhuma versão registrada.</div>;

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        {versions.map((version) => (
          <div key={version.id} className="p-3 border rounded-md">
            <div className="flex items-center justify-between">
              <div className="font-semibold">v{version.versionSemver}</div>
              <div className="text-xs text-gray-500">{new Date(version.created_at).toLocaleString()}</div>
            </div>
            <div className="text-sm text-gray-500">{version.notes || 'Sem notas'}</div>
          </div>
        ))}
      </div>
      {diff && (
        <div className="space-y-2">
          <div className="font-semibold">altima COMPARAÇÃO</div>
          <DiffList title="Alterados" entries={Object.entries(diff.changed ?? {})} render={(k, v) => `${k}: ${String(v.from)}   ${String(v.to)}`} />
          <DiffList title="Adicionados" entries={Object.entries(diff.added ?? {})} render={(k, v) => `${k}: ${String(v)}`} />
          <DiffList title="Removidos" entries={Object.entries(diff.removed ?? {})} render={(k, v) => `${k}: ${String(v)}`} />
        </div>
      )}
    </div>
  );
}

function DiffList({
  title,
  entries,
  render,
}: {
  title: string;
  entries: [string, unknown][];
  render: (k: string, v: any) => string;
}) {
  if (!entries.length) return null;
  return (
    <div>
      <div className="text-sm font-semibold">{title}</div>
      <ul className="list-disc list-inside text-sm text-gray-600">
        {entries.map(([k, v]) => (
          <li key={k}>{render(k, v)}</li>
        ))}
      </ul>
    </div>
  );
}

